export default {"src":"/_next/static/media/Webinar-Icon.0e4c7ee1.svg","height":27,"width":30};